import React from "react";
import Card from "react-bootstrap/Card";
import { ImHappy } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi! My name is <span className="green">Amanuel Reda.</span>
            I grew up and completed high school in <span className="green"> Addis Ababa, Ethiopia.</span>
            <br />I am computer science honors student at CSULB.
            <br />
            <br />
            Activities that I like to do in my free time are:
          </p>
          <ul>
            <li className="about-activity">
              <ImHappy /> Hiking
            </li>
            <li className="about-activity">
              <ImHappy /> Playing and watching soccer
            </li>
            <li className="about-activity">
              <ImHappy /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Everyone has an inner battle you know nothing about - be kind - always"{" "}
          </p>
          <footer className="blockquote-footer">Anonymous</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
